import React from 'react'

export default function(state, payload) {
  localStorage.removeItem('session-token');
  localStorage.removeItem('session-usrid');
  const message = payload.body && payload.body.message
  return {
  	...state, 
  	data: null, 
  	logged: false, 
  	logging: false, 
  	message: message,
  	success: false,
  };
}